RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Invoices = RivalIQ.views.CollectionView.mixin({
        className: 'x-invoice x-tile panel-body',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        childView: App.views.Invoice,

        emptyView: Marionette.ItemView.extend({
            template: '#invoicesEmptyTemplate'
        }),

        modelEvents: {
            'change': 'render'
        },

        loadData: function (callback) {
            const me = this;

            me.account = RivalIQ.state.account;
            $.when(
                me.account.getOwner(),
                RivalIQ.data.invoices.fetch()
            ).done(function (owner, invoices) {
                me.owner = owner;
                me.collection = invoices;
                callback();
            });
        },

        filter: function (child) {
            const me = this;
            return child.get('id') === me.getProp('actionTypeId');
        },

        childViewOptions: function () {
            const me = this;

            return {
                account: me.account,
                owner: me.owner
            };
        }
    });
});
